module.exports = __webpack_public_path__ + "static/img/detail1.4ce67fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/detail1.jpg
// module id = mjIQ
// module chunks = 0